// extracted by mini-css-extract-plugin
export default {"generalConditionL1":"GeneralConditionL1_generalConditionL1__7nmbT","smallPiegraph":"GeneralConditionL1_smallPiegraph__qP5Pg"};